import React from 'react';
import styled from 'styled-components';

import getImgxUrl from '@crehana/utils/dist/getImgxUrl';
import { ArrowIosRight } from '@crehana/icons/dist/outline';

import { CardFill } from '@crehana/icons';

import { PaymentMethodType } from 'Jsx/CheckoutV4/types';

import { useCheckoutContext } from 'Jsx/CheckoutV4/Context';

import CardLogos from '../Stripe/components/CardLogos';

interface StMethodProps {
  isSelected: boolean;
}

const StMethod = styled.button<StMethodProps>`
  border-color: ${props =>
    props.isSelected
      ? props.theme.colors.purple.main
      : props.theme.colors.gray.main};
  background: ${props =>
    props.isSelected
      ? props.theme.colors.purple['lighter-2']
      : props.theme.colors.white};
  transition: 0.3s;
  cursor: pointer;
  &:hover {
    border-color: ${props => props.theme.colors.primary.light};
  }
  pointer-events: auto;
  border-radius: 10px;
`;

interface MethodProps extends PaymentMethodType {
  selectAnotherPaymentMethod: (value: PaymentMethodType) => void;
  imageAlt?: string;
  isCard: boolean;
}

const Method: React.FC<MethodProps> = ({
  title,
  paymentGatewayId,
  offlineLabel,
  logoMiniatureUrl,
  text,
  maxAmount,
  extraCommission,
  slug,
  isSelected,
  logoUrl,
  selectAnotherPaymentMethod,
  imageAlt,
  isCard,
}) => {
  const { countryPrefix, productData } = useCheckoutContext();
  const areInstallmentsAvailable =
    countryPrefix === 'mx' &&
    title === 'Mercado Pago Card Mexico' &&
    (productData.itemType === 'membership' ||
      productData.itemType === 'degree');

  return (
    <StMethod
      onClick={() => {
        selectAnotherPaymentMethod({
          paymentGatewayId,
          title,
          offlineLabel,
          logoUrl,
          logoMiniatureUrl,
          text,
          maxAmount,
          extraCommission,
          slug,
          isSelected: true,
        });
      }}
      isSelected={isSelected}
      title={imageAlt || text || offlineLabel || title}
      className="flex items-center justify-between w-full border-2 border-solid h-72 rounded-5 px-24 bg-white"
    >
      <span>
        {isCard ? (
          <CardLogos />
        ) : (
          <img
            src={getImgxUrl(logoUrl!, { h: 24, dpr: 2, auto: 'format' })}
            alt={imageAlt || title}
            className="block h-24"
          />
        )}
      </span>
      <div className="flex items-center">
        {areInstallmentsAvailable && (
          <div className="flex items-center bg-primary-main rounded-5 px-8 py-4 mr-8">
            <CardFill size={16} color="white" />
            <p className="ml-4 font-link-2 text-white">PAGA EN CUOTAS</p>
          </div>
        )}
        <ArrowIosRight size={24} />
      </div>
    </StMethod>
  );
};

export default Method;
